(function (factory) {
  'use strict';
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else {
    const api = window.OffimobileRequiezSyncV1 || factory();
    window.OffimobileRequiezSyncV1 = api;
    const start = () => {
      if (!document.getElementById('product_form_8684978766067')) return;
      let observer, timer;
      const mount = () => {
        const shell = document.getElementById('tda-customizer-app-section-container-47103285428467');
        if (!shell) return false;
        shell.setAttribute('data-om-requiez-viewer', 'ergohuman');
        shell.setAttribute('data-product-id', '8684978766067');
        api.mount(shell, window);
        if (observer) observer.disconnect();
        if (timer) window.clearTimeout(timer);
        return true;
      };
      if (mount()) return;
      observer = new MutationObserver(mount);
      observer.observe(document.body, { childList: true, subtree: true });
      timer = window.setTimeout(() => observer.disconnect(), 60000);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  }
})(function () {
  'use strict';
  const selectedClass = 'tda-customizer-customization-option-value-selected';
  const choiceSelector = '[tda-variant-option-value]';
  const profiles = {
    '8684978766067': {
      modelId: '47103285428467', angleOptionId: '20xi2', angleIndex: 0,
      fields: ['option-0'], values: ['Malla Negra', 'Malla Gris'],
      variants: {
        '45661355540723': ['Malla Negra'],
        '45661464133875': ['Malla Gris']
      },
      allowed: ['45661355540723', '45661464133875']
    }
  };
  const mounted = new WeakMap();
  const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
  const numericId = value => typeof value === 'string' && /^\d+$/.test(value);
  const variantForOptions = (profile, values) => Object.keys(profile.variants)
    .find(id => profile.variants[id].every((value, index) => value === values[index])) || null;
  const permitNativeMedia = (productId, mediaType) => !own(profiles, String(productId)) || mediaType !== 'model';

  function mount(shell, win) {
    if (mounted.has(shell)) return mounted.get(shell);
    const productId = shell.getAttribute('data-product-id');
    if (!own(profiles, productId)) return null;
    const profile = profiles[productId];
    const doc = win.document;
    const form = doc.getElementById('product_form_' + productId);
    const modelId = profile.modelId || shell.getAttribute('data-angle-model-id');
    let disposed = false, writingAngle = false, writingTheme = false;
    let desired = null, revision = 0, task = null, attempts = 0, lastSelected = null;
    // Equality with an old master value does not acknowledge a newer async intent.
    // If unresolved native writes overlap, no available event proves they drained.
    // Latch closed for this mount instead of guessing a delay or writing the ID.
    let unconfirmedThemeIntent = false, themeCommitConflict = false;
    const removers = [];
    const modelRoot = () => numericId(modelId)
      ? shell.querySelector('#tda-customizer-app-section-wrapper-' + modelId) : null;
    const master = () => form?.querySelector('[name="id"]');
    const radios = index => Array.from(form?.querySelectorAll('input[type="radio"][name="' + profile.fields[index] + '"]') || []);
    const selectedOptions = () => profile.fields.map((_, index) => {
      const selected = radios(index).filter(radio => radio.checked);
      return selected.length === 1 ? selected[0].value : null;
    });
    const currentVariant = () => variantForOptions(profile, selectedOptions());
    const agreed = id => currentVariant() === id && String(master()?.value) === id;
    const allowed = id => profile.allowed.includes(id);
    const angleChoices = () => {
      const root = modelRoot();
      const scope = profile.angleOptionId
        ? root?.querySelector('#tda-customizer-customization-option-' + profile.angleOptionId) : root;
      return Array.from(scope?.querySelectorAll(choiceSelector) || [])
        .filter(choice => profile.values.includes(choice.getAttribute('tda-variant-option-value')));
    };
    function status(value) {
      shell.hidden = ['color-excluded', 'model-id-required', 'unknown-variant', 'form-missing', 'theme-controls-missing', 'theme-commit-unverified', 'timeout', 'stopped'].includes(value);
      shell.inert = value !== 'ready';
      shell.setAttribute('aria-hidden', value === 'ready' ? 'false' : 'true');
      shell.setAttribute('data-sync-state', value);
    }
    function cancel() {
      if (task !== null) win.clearTimeout(task);
      task = null;
    }
    function listen(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      removers.push(() => target.removeEventListener(type, handler, options));
    }
    function writeTheme(id) {
      const values = profile.variants[id];
      if (!values || !form) return false;
      const targets = values.map((value, index) => radios(index).filter(radio => radio.value === value));
      if (targets.some(matches => matches.length !== 1 || matches[0].disabled)) return false;
      writingTheme = true;
      try {
        let pendingWrite = false, clicked = false;
        targets.forEach(matches => {
          if (!matches[0].checked) {
            if (pendingWrite) themeCommitConflict = true;
            matches[0].click();
            clicked = true;
            pendingWrite = String(master()?.value) !== currentVariant();
          }
        });
        if (!clicked && String(master()?.value) !== id) targets.at(-1)[0].dispatchEvent(new win.Event('change', { bubbles: true }));
      } finally { writingTheme = false; }
      return true;
    }
    function replaceUrl(id) {
      const url = new win.URL(win.location.href);
      if (url.searchParams.get('variant') === id) return;
      url.searchParams.set('variant', id);
      win.history.replaceState(win.history.state, '', url.href);
    }
    function later(token) {
      if (++attempts >= 60) { status('timeout'); return; }
      cancel();
      task = win.setTimeout(() => { task = null; settle(token); }, 50);
    }
    function settle(token) {
      if (disposed || token !== revision) return;
      if (themeCommitConflict) { cancel(); status('theme-commit-unverified'); return; }
      if (!desired || !own(profile.variants, desired)) { status('unknown-variant'); return; }
      if (!agreed(desired)) { unconfirmedThemeIntent = true; status('waiting-theme'); later(token); return; }
      unconfirmedThemeIntent = false;
      replaceUrl(desired);
      if (!allowed(desired)) { status('color-excluded'); return; }
      if (!numericId(modelId)) { status('model-id-required'); return; }
      const choices = angleChoices();
      if (choices.length !== profile.values.length || profile.values.some(value =>
        choices.filter(choice => choice.getAttribute('tda-variant-option-value') === value).length !== 1)) {
        status('waiting-angle'); later(token); return;
      }
      const value = profile.variants[desired][profile.angleIndex];
      const target = choices.find(choice => choice.getAttribute('tda-variant-option-value') === value);
      if (target.disabled || target.getAttribute('aria-disabled') === 'true') { status('angle-disabled'); later(token); return; }
      if (!target.classList.contains(selectedClass)) {
        if (lastSelected !== target || attempts % 10 === 0) {
          writingAngle = true;
          try { target.click(); lastSelected = target; } finally { writingAngle = false; }
        }
        status('waiting-angle'); later(token); return;
      }
      if (choices.filter(choice => choice.classList.contains(selectedClass)).length !== 1) {
        status('ambiguous-angle'); return;
      }
      cancel();
      win.requestAnimationFrame(() => win.requestAnimationFrame(() => {
        if (disposed || token !== revision) return;
        if (agreed(desired) && allowed(desired) && modelRoot()?.contains(target)
          && target.classList.contains(selectedClass)
          && angleChoices().filter(choice => choice.classList.contains(selectedClass)).length === 1) status('ready');
        else { status('waiting-angle'); later(token); }
      }));
    }
    function request(id, updateTheme = false) {
      const nextDesired = id && own(profile.variants, id) ? id : null;
      // A lifecycle replay is not another user intent. Reuse its outstanding
      // commit and retry budget; never synthesize another native change for it.
      if (!themeCommitConflict && unconfirmedThemeIntent && nextDesired === desired) {
        if (task === null && agreed(desired)) settle(revision);
        return;
      }
      if (unconfirmedThemeIntent && nextDesired !== desired) themeCommitConflict = true;
      cancel(); revision += 1; attempts = 0; lastSelected = null;
      desired = nextDesired;
      if (themeCommitConflict) { status('theme-commit-unverified'); return; }
      status('synchronizing');
      if (updateTheme && desired && !writeTheme(desired)) { status('theme-controls-missing'); return; }
      settle(revision);
    }
    function fromLocation() {
      const url = new win.URL(win.location.href);
      const id = url.searchParams.get('variant');
      request(id === null ? String(master()?.value || '') : id, true);
    }
    function fromTheme(event) {
      if (writingTheme) return;
      if (!profile.fields.includes(event.target?.name) && event.target?.name !== 'id') return;
      request(event.target.name === 'id' ? String(master()?.value || '') : currentVariant());
    }
    function fromAngle(event) {
      if (themeCommitConflict) { status('theme-commit-unverified'); return; }
      const choice = event.target?.closest?.(choiceSelector);
      if (!choice || !modelRoot()?.contains(choice) || writingAngle) return;
      const id = currentVariant();
      if (!allowed(id) || !agreed(id)) { status('selection-unresolved'); return; }
      if (!angleChoices().includes(choice)) return;
      const value = choice.getAttribute('tda-variant-option-value');
      const values = profile.variants[id].slice();
      values[profile.angleIndex] = value;
      request(variantForOptions(profile, values), true);
    }
    function onReady() { request(desired); }
    status('initializing');
    const api = { stop() {
      disposed = true; cancel(); revision += 1; observer?.disconnect();
      removers.forEach(remove => remove()); mounted.delete(shell); status('stopped');
    }, getState() { return { productId, modelId: modelId || null, variantId: desired, state: shell.getAttribute('data-sync-state') }; } };
    mounted.set(shell, api);
    let observer;
    if (!form) { status('form-missing'); return api; }
    listen(form, 'change', fromTheme);
    listen(shell, 'click', fromAngle, true);
    listen(win, 'popstate', fromLocation);
    listen(win, 'pageshow', fromLocation);
    listen(win, 'Angle3DCustomizerReady', onReady);
    listen(win, 'Angle3DCustomizerLoaded', onReady);
    observer = new win.MutationObserver(records => {
      if (['theme-controls-missing', 'theme-commit-unverified', 'unknown-variant', 'model-id-required', 'form-missing', 'stopped'].includes(shell.getAttribute('data-sync-state'))) return;
      const relevant = records.some(record => record.type === 'childList'
        || record.attributeName === 'class' && angleChoices().includes(record.target));
      if (!relevant) return;
      const choices = angleChoices();
      const selected = choices.filter(choice => choice.classList.contains(selectedClass));
      if (shell.getAttribute('data-sync-state') === 'ready' && agreed(desired)
        && selected.length === 1 && selected[0].getAttribute('tda-variant-option-value') === profile.variants[desired]?.[profile.angleIndex]) return;
      if (!disposed && task === null) {
        status('synchronizing'); attempts = 0; settle(revision);
      }
    });
    observer.observe(shell, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    fromLocation();
    return api;
  }
  return { profiles, variantForOptions, permitNativeMedia, mount };
});
